/* eslint-disable jsx-a11y/anchor-is-valid */
import {Fade} from 'react-reveal';


export default function Footer() {

  return (
    <div className='flex flex-col w-full mt-7'>
               
                  <div className='mt-4 text-center border-t-2 border-gray-400 w-[70%] laptop:w-[25%] m-auto'>
                  <Fade bottom>
                    <h3 className='text-gray-500 pointer-events-none mt-3 font-englishTitle text-md'>Created By <a href="https://mshdp.ir" target='_blank' className='pointer-events-auto text-slate-500 hover:text-green-950'>Mehrshad Peyman</a></h3>
                  </Fade>
                  </div>
              </div>
  )
}
